module.exports = __webpack_public_path__ + "img/FLOWER HAT GREEN.d880f33.svg";